(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hbt-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hbt-newsletter-popup')) {
    customElements.define('hbt-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        if (!this.dialog || !this.form || !this.dialog.showModal) return;
        this.abort = new AbortController();
        this.storageKey = 'hbt-newsletter-popup-v1';
        this.pendingKey = 'hbt-newsletter-popup-pending';
        this.startedAt = Date.now();
        this.delay = Math.max(20, Number(this.dataset.delay) || 20) * 1000;
        this.frequency = Math.max(7, Number(this.dataset.frequency) || 7) * 86400000;
        this.state = {};
        try {
          const storedState = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
          this.state = storedState && typeof storedState === 'object' ? storedState : {};
          this.storageAvailable = true;
        } catch { this.storageAvailable = false; }
        this.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), { signal: this.abort.signal }));
        this.querySelector('[data-popup-preview]')?.addEventListener('click', () => this.open(true), { signal: this.abort.signal });
        this.dialog.addEventListener('close', () => this.onClose(), { signal: this.abort.signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal: this.abort.signal });
        this.form.addEventListener('submit', () => {
          try { sessionStorage.setItem(this.pendingKey, JSON.stringify({ id: this.form.id, at: Date.now() })); } catch {}
        }, { signal: this.abort.signal });
        const result = this.querySelector('[data-popup-result]');
        let pending;
        try { pending = JSON.parse(sessionStorage.getItem(this.pendingKey) || 'null'); } catch {}
        if (result?.dataset.popupResult === 'success') this.saveState({ subscribed: true });
        if (result && (location.hash === '#' + this.form.id || (pending?.id === this.form.id && Date.now() - pending.at < 1800000))) {
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
          this.open(true);
          result.focus({ preventScroll: true });
          return;
        }
        if (this.dataset.editor === 'true' || this.dataset.enabled !== 'true' || this.dataset.customerSubscribed === 'true' || !this.storageAvailable || this.state.subscribed || this.state.dismissedUntil > Date.now()) return;
        const schedule = event => {
          if (this.shown) return;
          const path = event?.composedPath?.() || [];
          if (path.some(node => node instanceof Element && node.matches('#honeypop-app, #shopify-chat, shopify-chat, #shopify-pc__banner, #shopify-pc__prefs'))) this.deferUntil = Date.now() + 60000;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.maybeOpen(), Math.max(650, this.startedAt + this.delay - Date.now(), (this.deferUntil || 0) - Date.now()));
        };
        window.addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
        document.addEventListener('pointerup', schedule, { passive: true, signal: this.abort.signal });
        document.addEventListener('focusout', schedule, { signal: this.abort.signal });
        document.addEventListener('visibilitychange', schedule, { signal: this.abort.signal });
        schedule();
      }
      isVisible(element) {
        const box = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      }
      isBusy() {
        let active = document.activeElement;
        while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
        if (active?.matches('input, textarea, select, [contenteditable="true"], iframe')) return true;
        const blockers = 'dialog[open], [role="dialog"][aria-modal="true"], details.menu-drawer-container[open], details-modal details[open], cart-drawer.active, .cart-drawer.active, #shopify-pc__banner, #shopify-pc__prefs';
        if ([...document.querySelectorAll(blockers)].some(element => !this.contains(element) && this.isVisible(element))) return true;
        const rewards = document.getElementById('honeypop-app');
        if (rewards && [...rewards.children].some(element => {
          const rect = element.getBoundingClientRect();
          return rect.width > 160 && rect.height > 160 && this.isVisible(element);
        })) return true;
        return [...document.querySelectorAll('iframe[title*="chat" i], iframe[title*="rewards" i]')].some(element => element.getBoundingClientRect().height > 160 && this.isVisible(element));
      }
      maybeOpen() {
        if (this.shown || document.visibilityState !== 'visible' || Date.now() - this.startedAt < this.delay || Date.now() < (this.deferUntil || 0)) return;
        const availableScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (availableScroll <= 0 || window.scrollY / availableScroll < .25 || this.isBusy()) return;
        this.open();
      }
      open(force = false) {
        if (this.dialog.open || (!force && this.isBusy())) return;
        this.shown = true;
        clearTimeout(this.timer);
        this.dialog.showModal();
        document.body.classList.add('hbt-newsletter-popup-open');
        this.querySelector('.hbt-newsletter-popup__title').focus({ preventScroll: true });
      }
      saveState(update) {
        this.state = { ...this.state, ...update };
        if (this.dataset.editor === 'true') return;
        try { localStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch {}
      }
      onClose() {
        document.body.classList.remove('hbt-newsletter-popup-open');
        this.saveState({ dismissedUntil: Date.now() + this.frequency });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        if (this.dialog?.open) { this.dialog.close(); document.body.classList.remove('hbt-newsletter-popup-open'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
